<div class="mat-dialog-custom">
  <mat-dialog-content>
    <div class="header-dialog-custom">
      <div class="btn-close-right" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <div class="body-dialog-custom">
      <div class="d-flex align-items-center mt-2 mb-2">
        <button  class="btn btn-custom-style1 today-btn" (click)="today()">本日</button>
        <div class="d-flex align-items-center justify-content-center year-btn">
          <div class="txt-right mr-2">
            <button
              class="btn btn-custom-style1 navigate-btn"
              (click)="changeYear('previous', isDisableDays)"
              [disabled]="!isDateInputView"
              [ngClass]="isDisableDays ? 'th-not-allowed' : ''">
              <mat-icon svgIcon="calendar_previous" aria-hidden="false"></mat-icon>
            </button>
          </div>
          <div>
            <div class="mar-bot">{{ yearNormal }}年</div>
          </div>
          <div class="txt-left ml-2">
            <button
              class="btn btn-custom-style1 navigate-btn"
              (click)="changeYear('next', isDisableDays)"
              [disabled]="!isDateInputView"
              [ngClass]="isDisableDays ? 'th-not-allowed' : ''">
              <mat-icon svgIcon="calendar_next" aria-hidden="false"></mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="calendar-table mt-10" [ngClass]="isDateInputView ? 'table-date-view' : 'table-date-edit'">
        <div class="d-flex align-items-center justify-content-center mt-1">
          <div
            colspan="3"
            class="background-header-title right"
            [ngClass]="isDateInputView ? 'table-date-view' : 'op03'">
            <button
              class="btn btn-custom-style1 navigate-btn"
              (click)="changeMonth('previous', isDisableDays)"
              [disabled]="!isDateInputView"
              [ngClass]="isDisableDays ? 'th-not-allowed' : ''">
              <mat-icon svgIcon="calendar_previous" aria-hidden="false"></mat-icon>
            </button>
          </div>
          <div
            colspan="1"
            class="background-header-title center font-weight-bolder"
            [ngClass]="isDateInputView ? 'table-date-view' : 'op03'">
            <div class="mar-bot">{{ month }}月</div>
          </div>
          <div
            colspan="3"
            class="background-header-title left"
            [ngClass]="isDateInputView ? 'table-date-view' : 'op03'">
            <button
              class="btn btn-custom-style1 navigate-btn"
              (click)="changeMonth('next', isDisableDays)"
              [disabled]="!isDateInputView"
              [ngClass]="isDisableDays ? 'th-not-allowed' : ''">
              <mat-icon svgIcon="calendar_next" aria-hidden="false"></mat-icon>
            </button>
          </div>
        </div>
        <table class="table table-bordered border-0 m-0">
          <thead class="thead-light">
            <tr>
              <th
                *ngFor="let dayTitle of dayOfWeekTitles"
                class="background-header-title"
                [ngClass]="isDateInputView ? 'table-date-view' : 'op03'">
                <span style="font-size: 14px">{{ dayTitle }}</span>
              </th>
            </tr>
          </thead>
          <tbody [ngClass]="isDateInputView ? 'table-date-view' : 'tbody-disable'">
            <tr *ngFor="let weekNumber of [].constructor(6); let idxWeek = index">
              <td
                *ngFor="let dayNumber of [].constructor(7); let idxDay = index"
                (click)="daysInMonth[idxWeek * 7 + idxDay].isDisDay ? '' : clickCell(idxWeek, idxDay)"
                [ngClass]="{
                  'selected-cell-previous': daysInMonth[idxWeek * 7 + idxDay].isDisDay,
                  'selected-cell': selectedCell.day.getTime() === daysInMonth[idxWeek * 7 + idxDay].date.getTime(),
                  'has-data': daysInMonth[idxWeek * 7 + idxDay].hasData
                }"
                (dblclick)="daysInMonth[idxWeek * 7 + idxDay].isDisDay ? '' : onConfirm(idxWeek, idxDay)">
                <div>
                  <div hidden>{{ daysInMonth[idxWeek * 7 + idxDay] | json }} {{ selectedCell.day }}</div>
                  <span
                    [ngClass]="{
                      'tbody-disable': !isDateInputView,
                      'text-muted': !daysInMonth[idxWeek * 7 + idxDay].isInBound
                    }"
                    >{{ daysInMonth[idxWeek * 7 + idxDay].day }}</span
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center mt-2">
        <button class="btn btn-primary btn-confirm" (click)="onConfirmOK()" [disabled]="!isDateInputView">
          {{ 'CALENDAR_COMMON.OK_BTN' | translate }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
</div>
